import React from "react";
import { FormattedMessage } from "react-intl";
import moment from "moment-timezone";

class ValidationTicketItem extends React.Component {
  componentWillReceiveProps(nextProps) {
    this.props = nextProps;
  }

  render() {
    const {
      ticketId,
      venueCapacityName,
      buyerTypeName,
      numValidatedTickets,
      numTickets,
      reservationId,
      promotionName,
      promotionColor,
      startDateTime,
      endDatetime,
    } = this.props;

    return (
      <table className="table table-bordered table-responsive">
        <tbody>
          <tr>
            <td rowSpan="2" className="text-left">
              {venueCapacityName && (
                <div>
                  <label className="label-custom">
                    <FormattedMessage
                      defaultMessage="Tipo de entrada"
                      id="label.type.ticket"
                    />
                  </label>
                  <p> {venueCapacityName} </p>
                </div>
              )}

              {buyerTypeName && (
                <div>
                  <label className="label-custom">
                    <FormattedMessage
                      defaultMessage="Colectivo"
                      id="label.type.buyer"
                    />
                  </label>
                  <p> {buyerTypeName} </p>
                </div>
              )}

              {numValidatedTickets && (
                <div>
                  <label className="label-custom">
                    <FormattedMessage
                      defaultMessage="Tickets validados"
                      id="label.validated.tickets"
                    />
                  </label>
                  <p>
                    {" "}
                    {`${numValidatedTickets} de ${
                      numTickets ? numTickets : 1
                    }`}{" "}
                  </p>
                </div>
              )}
            </td>

            <td className="text-center">
              <label className="label-custom">
                <FormattedMessage
                  defaultMessage="Localicador de reserva"
                  id="label.locator.reservation"
                />
              </label>
              <p>{reservationId}</p>
            </td>

            <td className="text-center">
              {startDateTime !== "" && startDateTime !== "" ? (
                <div>
                  <label className="label-custom">
                    {moment(startDateTime).format("DD/MM/YYYY")}
                  </label>
                  <p>
                    {moment(startDateTime).parseZone().format("HH:mm:ss")} -{" "}
                    {moment(endDatetime).parseZone().format("HH:mm:ss")}
                  </p>
                </div>
              ) : (
                <div>
                  <p>
                    <FormattedMessage
                      defaultMessage="Sin datos"
                      id="result.not.set"
                    />
                  </p>
                </div>
              )}
            </td>
          </tr>

          <tr className="text-center">
            <td>
              <label className="label-custom">
                <FormattedMessage
                  defaultMessage="Localizador de entrada"
                  id="label.locator.ticket"
                />
              </label>
              <p>{ticketId}</p>
            </td>

            <td>
              {promotionName && (
                <div className="promotion">
                  <div>
                    <span
                      style={promotionColor ? { color: promotionColor } : {}}
                      className="icon-own-star"
                    >
                      {" "}
                    </span>
                  </div>
                  <div className="text-left">
                    <label className="label-custom">
                      <FormattedMessage
                        defaultMessage="Promoción"
                        id="label.promotion"
                      />
                    </label>
                    <br />
                    <label className="label-custom">{promotionName}</label>
                  </div>
                </div>
              )}
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}

export default ValidationTicketItem;
